var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.33008V14.5301C10 16.2102 10 17.0503 10.327 17.6921C10.6146 18.2565 11.0735 18.7155 11.638 19.0031C12.2798 19.3301 13.1198 19.3301 14.8 19.3301H15M15 19.3301C15 20.4346 15.8954 21.3301 17 21.3301C18.1046 21.3301 19 20.4346 19 19.3301C19 18.2255 18.1046 17.3301 17 17.3301C15.8954 17.3301 15 18.2255 15 19.3301ZM5 3.33008L15 3.33008M5 3.33008C5 4.43465 4.10457 5.33008 3 5.33008C1.89543 5.33008 1 4.43465 1 3.33008C1 2.22551 1.89543 1.33008 3 1.33008C4.10457 1.33008 5 2.22551 5 3.33008ZM15 3.33008C15 4.43465 15.8954 5.33008 17 5.33008C18.1046 5.33008 19 4.43465 19 3.33008C19 2.22551 18.1046 1.33008 17 1.33008C15.8954 1.33008 15 2.22551 15 3.33008ZM10 11.3301H15M15 11.3301C15 12.4346 15.8954 13.3301 17 13.3301C18.1046 13.3301 19 12.4346 19 11.3301C19 10.2255 18.1046 9.33008 17 9.33008C15.8954 9.33008 15 10.2255 15 11.3301Z",
    stroke: "#F4FBFC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetList);
export default __webpack_public_path__ + "static/media/asset-list.374d764036fc29d276aaa5812cc92e6e.svg";
export { ForwardRef as ReactComponent };